import type { AgentItem } from '@/types/agent'

/** A draft answered with guidance, until the agent posts something newer (its redraft). */
export const awaitingRedraft = (item: AgentItem, all: AgentItem[]) => {
  if (item.status !== 'answered' || item.answer?.optionId !== 'guidance') return false
  const answeredAt = Date.parse(item.answer.at)
  return !all.some(other => other._id !== item._id && Date.parse(other.createdAt) > answeredAt)
}
